<template class="formDialog">
  <v-dialog
    v-model="dialog"
    max-width="1000px"
    :persistent="true"
  >
    <v-form
      ref="form"
    >
      <v-card class="pa-4">
        <v-card-title>
          <v-icon
            style="font-size: 35px; color: #43BA7E;"
            class="mr-2"
          >
            mdi-qrcode
          </v-icon>
          <h2>
            New QR Code -
            {{ qrCodeNumber }}
          </h2>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-column ga-3">
            <div class="d-flex align-center ga-2 pb-2 pt-2">
              <v-icon style="font-size: 30px; color: #3F76D4;">
                mdi-package-variant-closed
              </v-icon>
              <h2 style="color: #000">
                Item Information
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <inventory-class-select-element
                v-model="inventoryClassId"
                :is-required="true"
                :is-upc="true"
                :disabled="data != null"
                item-value="id"
                style="max-width: 200px;"
              />
              <v-autocomplete
                v-model="inventoryItemId"
                :items="inventoryItems"
                item-value="id"
                :loading="loadingInventoryItem"
                :item-text="
                  (item) => item.material_id + ': ' + item.name
                "
                :rules="[(v) => !!v || 'Inventory Item is required']"
                :disabled="data != null"
                @change="onInventoryItemChange"
              >
                <template #item="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item && item.classes ? item.classes.color : 'white'"
                  >
                    {{ item && item.classes ? item.classes.name : '' }}
                  </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                </template>
                <!-- eslint-disable-next-line vue/no-template-shadow -->
                <template #selection="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item && item.classes ? item.classes.color : 'white'"
                  >
                    {{ item && item.classes ? item.classes.name : '' }}
                  </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                </template>
                <template slot="label">
                  Inventory Item<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="subClasses"
                label="Sub Classes"
                :items="subClassesList"
                item-text="name"
                item-value="id"
                multiple
                disabled
              >
                <template #item="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item ? item.color : 'white'"
                  >
                    {{ item ? item.name : '' }}
                  </v-chip>
                </template>
                <template #selection="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item ? item.color : 'white'"
                  >
                    {{ item ? item.name : '' }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="isPhysicalCountActivated || lencolToggle"
                v-model="length"
                :items="lengthList"
                auto-select-first
                :loading="loadingLength"
                item-text="name"
                item-value="id"
                style="max-width: 200px;"
              >
                <template slot="label">
                  Length
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="uom"
                :items="uomsList"
                auto-select-first
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'UOM is required']"
                :loading="loadingUom"
                :disabled="data != null"
              >
                <template slot="label">
                  UOM<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="isPhysicalCountActivated || lencolToggle"
                v-model="color"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  Color
                </template>
              </v-autocomplete>
            </div>
            <div class="d-flex align-center ga-2 pb-2">
              <v-icon style="font-size: 30px; color: purple;">
                mdi-map-marker-outline
              </v-icon>
              <h2 style="color: #000">
                Location & Storage
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <v-autocomplete
                v-model="locationId"
                :items="locationsList"
                auto-select-first
                :loading="loadingLocation"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Location is required']"
              >
                <template slot="label">
                  Location<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="shelfId"
                :items="inventoryLocations"
                :loading="loadingShelf"
                item-text="name"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Shelf is required']"
              >
                <template slot="label">
                  Shelf<RedAsterisk />
                </template>
              </v-autocomplete>
            </div>
            <div class="d-flex align-center ga-2 pb-2">
              <v-icon style="font-size: 30px; color: red;">
                mdi-truck-outline
              </v-icon>
              <h2 style="color: #000">
                Order & Supply Information
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <v-autocomplete
                v-if="isPhysicalCountActivated"
                v-model="po_number"
                :loading="loadingInventoryPos"
                :items="inventoryPos"
                :clearable="true"
                label="PO#"
                :rules="!isCurrentPhysicalCountClassesMatchInventoryClassSelection ? [(v) => !!v || 'PO# is required'] : []"
              >
                <template slot="label">
                  PO#<RedAsterisk v-if="!isCurrentPhysicalCountClassesMatchInventoryClassSelection" />
                </template>
              </v-autocomplete>
              <v-text-field
                v-model="quantity"
                :rules="[(v) => !!v || 'Quantity is required']"
                type="number"
              >
                <template slot="label">
                  Quantity<RedAsterisk />
                </template>
              </v-text-field>
              <div
                v-if="!isPhysicalCountActivated"
                style="width: 200px"
              >
                <h3 class="h3">
                  Limit Level
                </h3> <span> {{ dangerLevel ? dangerLevel.limit_level : '-' }}</span>
              </div>
              <div
                v-if="!isPhysicalCountActivated"
                style="width: 200px"
              >
                <h3 class="h3">
                  Danger Level
                </h3> <span> {{ dangerLevel ? dangerLevel.danger_level : '-' }}</span>
              </div>
            </div>
            <div
              v-if="isPhysicalCountActivated"
              class="d-flex align-center ga-3"
            >
              <div style="width: 200px">
                <h3 class="h3">
                  Limit Level
                </h3> <span> {{ dangerLevel ? dangerLevel.limit_level : '-' }}</span>
              </div>
              <div style="width: 200px">
                <h3 class="h3">
                  Danger Level
                </h3> <span> {{ dangerLevel ? dangerLevel.danger_level : '-' }}</span>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            large
            color="normal"
            class="mr-2"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            large
            color="primary"
            @click="submitForm"
          >
            {{ btnSubmitName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import InventoryLocationsApi from '@/api/InventoryLocationsApi';
import InventoryTagsApi from '@/api/InventoryTagsApi';
import LocationsApi from '@/api/LocationsApi';
import { mapGetters, mapState } from 'vuex';
import UomsApi from '@/api/UomsApi';
import LengthsApi from '../../../api/LengthsApi';

export default {
  components: { },
  props: {
    enteredTag: {
      type: String,
      default: '',
    },
    isShowPO: {
      type: Boolean,
      default: false,
    },
    isShowLocation: {
      type: Boolean,
      default: false,
    },
    defaultLocation: {
      type: Object,
      default: () => {},
    },
    defaultShelf: {
      type: Object,
      default: () => {},
    },
    defaultQuantity: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    // Inventory Item
    uom: 0,
    length: null,
    color: null,
    inventoryTag: null,
    inventoryItemId: null,
    shelfId: 0,
    quantity: '',
    userId: null,
    po_number: '',
    inventoryClasses: '',
    locationId: '',
    isQrEqualsTag: 0,
    qrCodeNumber: '',
    inventoryClassId: 4,
    supplierLabel: null,

    // Inventory
    uomsList: [],
    inventoryItems: [],
    inventoryLocations: [],
    locationsList: [],
    inventoryPos: [],
    colorsList: [],
    lengthList: [],
    subClassesList: [],
    subClasses: [],

    // DangerLevel
    dangerLevel: null,
    classPartsId: 11,

    // Form
    dialog: false,
    btnSubmitName: 'ADD',
    loadingUom: false,

    // Loading
    loadingInventoryItem: false,
    loadingLength: false,
    loadingColor: false,
    loadingUom: false,
    loadingLocation: false,
    loadingShelf: false,
    loadingInventoryPos: false,

    data: null,
  }),
  computed: {
    lencolToggle() {
      console.log(this.data);
      return this.$store.getters['businessRulesGetBoolean']('Add Length And Color')
    },
    ...mapGetters([
      'businessRulesGetBoolean',
      'isPhysicalCountActivated',
      'currentPhysicalCount',
    ]),
    ...mapState({
      user: 'user',
      invClasses: 'invClasses',
    }),
    isCurrentPhysicalCountClassesMatchInventoryClassSelection() {
      if (!this.isPhysicalCountActivated || !this.currentPhysicalCount || !this.currentPhysicalCount.classes) {
        return false;
      }
      return this.currentPhysicalCount.classes.some((c) => c.id === this.inventoryClassId);
    },
  },
  watch: {
    enteredTag(value) {
      if (this.isQrEqualsTag) { this.inventoryTag = value; }

      this.qrCodeNumberNumber = value;
    },
    locationId(value) {
      if (!value) return;
      this.fetchInventoryLocations();
    },
    inventoryClassId() {
      this.fetchInventoryItems();
      this.fetchInventoryPos();
    },
  },
  created() {
    const QrEqualsTagBRName = 'QR Code Equals Inv. Tag';
    this.isQrEqualsTag = this.businessRulesGetBoolean(QrEqualsTagBRName);

    this.initialize();
  },
  methods: {
    async initialize() {
      this.fetchUoms();
      this.fetchInventoryItems();
      this.fetchLocations();
      this.fetchInventoryLocations();
      this.fetchInventoryPos();
      this.fetchColors();
      console.log('Fetching Lengths List on Initialize...');
      this.fetchLengths();
      await this.getInventoryTag();
      this.getSubClasses();
      if (!this.user) return;
      this.userId = this.user.id;
    },
    async getSubClasses() {
      this.subClassesList = await this.$api.inventorySubClass.getList();
      this.subClasses = this.inventoryTag.inventory_sub_class_ids;
    },
    async getInventoryTag() {
      const submitModel = {
        filters: {
          inventory_item_id: this.inventoryItemId,
          is_qty_on_hand_o: 0,
        },

        pagination: { itemsPerPage: -1, page: 1 },
      };

      const res = await this.$api.inventoryTag.read(submitModel);
      if (res && res.data && res.data.length > 0) {
        this.inventoryTag = res.data[0];
      } else {
        this.inventoryTag = null;
      }
    },
    async fetchUoms() {
      this.uomsList = await UomsApi.getList();
    },
    async fetchInventoryItems() {
      this.inventoryItems = [];
      this.loadingInventoryItem = true;
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
        },
      };

      const res = await this.$api.inventoryItem.readDataSecondary(readModel);
      this.loadingInventoryItem = false;
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.inventoryItems = [];
        return;
      }
      this.inventoryItems = res.data;
    },
    async fetchInventoryLocations() {
      this.loadingShelf = true;
      const readModel = {
        filters:
        {
          location_id: this.locationId,
        },
      };
      this.inventoryLocations = await InventoryLocationsApi.read(readModel);
      this.loadingShelf = false;
    },
    async fetchLocations() {
      this.loadingLocation = true;
      this.locationsList = await LocationsApi.getList();
      this.loadingLocation = false;
    },
    async fetchLengths() {
      console.log('Fetching Lengths List...');
      this.lengthList = await LengthsApi.getList();
      console.log('Lengths List:', this.lengthList);
    },
    async fetchDangerLevel() {
      const inventoryItem = this.inventoryItems.find((x) => x.id === this.inventoryItemId);
      if (!inventoryItem) {
        this.dangerLevel = null;
        return;
      }
      if (inventoryItem.inventory_class_id !== this.classPartsId) return;
      const submitModel = {
        filters: {
          inventory_item_id: this.inventoryItemId,
        },
      };

      const res = await this.$api.dangerLevel.read(submitModel);
      if (!res || res.length < 1) {
        this.dangerLevel = null;
        return;
      }

      const firstIndex = 0;
      this.dangerLevel = res[firstIndex];
    },
    async fetchInventoryPos() {
      this.loadingInventoryPos = true;
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryClassId,
        },
      };
      const res = await this.$api.inventoryPo.read(submitModel, null, 'read-simple');
      this.loadingInventoryPos = false;
      if (!res) {
        return;
      }
      this.inventoryPos = res;
    },
    async fetchColors() {
      this.loadingColor = true;
      const submitModel = {
        filters: {
        },
      };

      this.colorsList = await this.$api.color.read(submitModel);
      console.log('Colors List:', this.colorsList);
      this.loadingColor = false;
    },
    async getLengths() {
      this.loadingLength = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryItemId,
          inventory_class_id: this.inventoryClassId,
        },
      };
      this.lengthList = await this.$api.length.read(submitData);
      this.loadingLength = false;
    },
    async getUoms() {
      this.loadingUom = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryItemId,
        },
      };
      this.uomsList = await this.$api.uom.read(submitData);
      this.loadingUom = false;
    },

    onInventoryItemChange() {
      this.uom = null;
      this.fetchDangerLevel();
      this.getUoms();
      this.getLengths();
    },

    async submitForm() {
      if (this.isPhysicalCountActivated) {
        // if physical count is activated then if po_number is selected, then we need to query the inventory po and find the inventory po item associated with the currently selected parameters
        if (this.po_number) {
          const submitData = {
            filters: {
              po_number: this.po_number,
              inventory_item_id: this.inventoryItemId,
              uom_id: this.uom,
              length_id: this.length,
              color_id: this.color,
            },
          };

          const res = await this.$api.inventoryPoItem.read(submitData);
          if (!res || res.length === 0) {
            this.$bus.$emit('showError', 'No matching PO Item found for the selected parameters');
            return;
          }

          // set inventory_po_item_id in data
          this.data = this.data || {};
          this.data.inventory_po_item_id = res[0].id;
          this.data.inventory_po_id = res[0].inventory_po_id;
        }
      }

      if (this.$refs.form.validate()) {
        this.$bus.$emit('loading');
        const data = new FormData();

        // Qr Code is treated as inv tag for now
        if (this.qrCodeNumberNumber) {
          data.append('inventory_tag', this.qrCodeNumberNumber);
        }

        if (this.inventoryItemId) {
          data.append('inventory_item_id', this.inventoryItemId);
        }

        if (this.uom) {
          data.append('uom_id', this.uom);
        }

        if (this.shelfId) {
          data.append('inventory_location_id', this.shelfId);
        }

        if (this.quantity) {
          data.append('quantity', this.quantity);
          data.append('upc_received_quantity', this.quantity);
        }
        if (this.user.id) {
          data.append('created_by', this.user.id);
        }

        if (this.locationId) {
          data.append('location_id', this.locationId);
        }

        if (this.po_number) {
          data.append('po_number', this.po_number);
        }

        if (this.data && this.data.inventory_po_item_id) {
          data.append('inventory_po_item_id', this.data.inventory_po_item_id);
        }
        if (this.subClasses && this.subClasses.length > 0){
          data.append('sub_classes', JSON.stringify(this.subClasses));
        }

        if (this.length) {
          data.append('length_id', this.length);
        }

        if (this.color) {
          data.append('color_id', this.color);
        }

        const res = await InventoryTagsApi.addUpc(data);
        if (!res) {
          this.$bus.$emit('showError');
          this.$bus.$emit('loading-stop');
          return;
        }

        if (this.po_number) {
          const submitData = new FormData();

          if (this.data.inventory_po_id) {
            submitData.append('inventory_po_id', this.data.inventory_po_id);
          }

          if (this.data.packaging_slip) {
            submitData.append('packaging_slip', this.data.packaging_slip);
          }

          if (this.data.packaging_slip_img) {
            submitData.append('packaging_slip_img', this.data.packaging_slip_img);
          }

          const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

          if (!resPo) {
            this.$bus.$emit('showError');
            this.$bus.$emit('loading-stop');
            return;
          }
        }

        this.$bus.$emit('loading-stop');
        this.$emit('submitQRCodeTag', 'QR Code has been added to ERP');
        this.data = null;
        this.closeDialog();
      }
    },

    openDialog(data) {
      this.dialog = true;
      this.inventoryClassId = 4;
      if (this.isQrEqualsTag) { this.inventoryTag = this.enteredTag; }

      this.qrCodeNumberNumber = this.enteredTag;

      // set default values

      // UOM
      if (this.uomsList.length) {
        const uomIdBox = 2;
        const uom = this.uomsList.find((x) => x.id === uomIdBox);
        if (uom) { this.uom = uom.id; } else { this.uom = 0; }
      } else { this.uom = 0; }

      // Location
      // If is set prop defaultLocation
      // else get first record from the list
      //   if (this.defaultLocation) {
      //     this.locationId = this.defaultLocation.id;
      //   } else if (this.locationsList.length && this.locationsList[0].id) {
      //     const locationId = this.locationsList[0].id;
      //     if (locationId) { this.locationId = locationId; } else { this.locationId = 0; }
      //   } else { this.locationId = 0; }

      //   // Shelf
      //   // If is set prop defaultShelf
      //   if (this.defaultShelf) {
      //     this.shelfId = this.defaultShelf.id;
      //   }

      // Quantity
      // If is set prop defaulQuantity
      if (this.defaultQuantity) {
        this.quantity = this.defaultQuantity;
      }

      if (data) {
        this.inventoryClassId = data.inventory_class_id || null;
        this.inventoryItemId = data.inventory_item_id || null;
        this.uom = data.uom_id || null;
        this.length = data.length_id || null;
        this.color = data.color_id || null;
        this.po_number = data.po_number || null;
        this.projectId = data.project_id || null;
        this.locationId = data.location_id || null;

        this.data = data;
      }
    },
    closeDialog() {
      this.$refs.form.reset();
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.mrp-btn-add {
  min-width: 35px !important;
  padding: 0 !important;
}
.v-text-field >>> input {
    font-size: 1.5em !important;
}
.v-autocomplete >>> input{
    font-size: 1.5em !important;
}
.v-autocomplete >>> label{
    font-size: 1.3em !important;
}
.v-text-field >>> label {
    font-size: 1.3em !important;
}
.v-btn {
    font-size: 1.1em !important;
}
/* v-autocomplete highlight color */
.theme--light.v-list-item .v-list-item__mask {
    background: #e6e90a !important;
}
</style>
